/**
 * Emergency Room
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@meddv.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { MedicalAccess } from '../models/medicalAccess';
import { MedicalAccessList } from '../models/medicalAccessList';

import { ConfigRESTServable, Configuration } from '@nida-web/api/generic-interfaces/config';

@Injectable({
  providedIn: 'root',
})
export class MedicalAccessService {
  protected apiPrefix = '';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, private configSubject: ConfigRESTServable) {
    this.configSubject.getRESTURL().subscribe((apiUrl) => {
      this.apiPrefix = apiUrl + 'er';
    });
  }

  /**
   *
   * Create new Access Point Information
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMedicalAccess(body: MedicalAccess, observe?: 'body', reportProgress?: boolean): Observable<MedicalAccess>;
  public createMedicalAccess(body: MedicalAccess, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicalAccess>>;
  public createMedicalAccess(body: MedicalAccess, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicalAccess>>;
  public createMedicalAccess(body: MedicalAccess, observe: any = 'body', reportProgress = false): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling createMedicalAccess.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<MedicalAccess>('post', `${this.apiPrefix}/medical-access`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   * Delete medical access
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteMedicalAccess(id: number, observe?: 'body', reportProgress?: boolean): Observable<string>;
  public deleteMedicalAccess(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
  public deleteMedicalAccess(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
  public deleteMedicalAccess(id: number, observe: any = 'body', reportProgress = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteMedicalAccess.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request<string>('delete', `${this.apiPrefix}/medical-access/${encodeURIComponent(String(id))}`, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      responseType: 'text',
    });
  }

  /**
   *
   * Get Medical Access List by Preclinic
   * @param preclinicId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMedicalAccessByPreclinic(preclinicId: number, observe?: 'body', reportProgress?: boolean): Observable<MedicalAccessList>;
  public getMedicalAccessByPreclinic(
    preclinicId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<MedicalAccessList>>;
  public getMedicalAccessByPreclinic(
    preclinicId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<MedicalAccessList>>;
  public getMedicalAccessByPreclinic(preclinicId: number, observe: any = 'body', reportProgress = false): Observable<any> {
    if (preclinicId === null || preclinicId === undefined) {
      throw new Error('Required parameter preclinicId was null or undefined when calling getMedicalAccessByPreclinic.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request<MedicalAccessList>(
      'get',
      `${this.apiPrefix}/preclinic/${encodeURIComponent(String(preclinicId))}/medical-access`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Get Medical Access List by Therpay
   * @param therapyId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMedicalAccessByTherapy(therapyId: number, observe?: 'body', reportProgress?: boolean): Observable<MedicalAccessList>;
  public getMedicalAccessByTherapy(
    therapyId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<MedicalAccessList>>;
  public getMedicalAccessByTherapy(
    therapyId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<MedicalAccessList>>;
  public getMedicalAccessByTherapy(therapyId: number, observe: any = 'body', reportProgress = false): Observable<any> {
    if (therapyId === null || therapyId === undefined) {
      throw new Error('Required parameter therapyId was null or undefined when calling getMedicalAccessByTherapy.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request<MedicalAccessList>(
      'get',
      `${this.apiPrefix}/therapy/${encodeURIComponent(String(therapyId))}/medical-access`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   * Update MedicalAccess
   * @param body
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMedicalAccess(body: MedicalAccess, id: number, observe?: 'body', reportProgress?: boolean): Observable<MedicalAccess>;
  public updateMedicalAccess(
    body: MedicalAccess,
    id: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<MedicalAccess>>;
  public updateMedicalAccess(
    body: MedicalAccess,
    id: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<MedicalAccess>>;
  public updateMedicalAccess(body: MedicalAccess, id: number, observe: any = 'body', reportProgress = false): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling updateMedicalAccess.');
    }

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateMedicalAccess.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<MedicalAccess>('put', `${this.apiPrefix}/medical-access/${encodeURIComponent(String(id))}`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
